import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { TruthSection } from '../components/TruthSection';
import { ProductPresentation } from '../components/ProductPresentation';
import { ContentBreakdown } from '../components/ContentBreakdown';
import { BenefitsSection } from '../components/BenefitsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ForYouSection } from '../components/ForYouSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { BonusSection } from '../components/BonusSection';
import { ValueStack } from '../components/ValueStack';
import { FAQSection } from '../components/FAQSection';
import { ImpactPhrases } from '../components/ImpactPhrases';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-[#FFF8F0] font-sans selection:bg-[#FFCC80] selection:text-gray-900" data-id="element-1123">
      <HeroSection data-id="element-1124" />
      <PainSection data-id="element-1125" />
      <TruthSection data-id="element-1126" />
      <ProductPresentation data-id="element-1127" />
      <ContentBreakdown data-id="element-1128" />
      <BenefitsSection data-id="element-1129" />
      <TestimonialsSection data-id="element-1130" />
      <ForYouSection data-id="element-1131" />
      <GuaranteeSection data-id="element-1132" />
      <BonusSection data-id="element-1133" />
      <ValueStack data-id="element-1134" />
      <FAQSection data-id="element-1135" />
      <ImpactPhrases data-id="element-1136" />
      <Footer data-id="element-1137" />
    </div>;
}